export enum ChemistryReactionRole {
  REACTANT = 'REACTANT',
  PRODUCT = 'PRODUCT',
  CATALYST = 'CATALYST',
  SOLVENT = 'SOLVENT',
  BYPRODUCT = 'BYPRODUCT',
}

export const CHEMISTRY_REACTION_ROLE_TO_DISPLAY_NAME: Record<ChemistryReactionRole, string> = {
  [ChemistryReactionRole.REACTANT]: 'Reactant',
  [ChemistryReactionRole.PRODUCT]: 'Product',
  [ChemistryReactionRole.CATALYST]: 'Catalyst',
  [ChemistryReactionRole.SOLVENT]: 'Solvent',
  [ChemistryReactionRole.BYPRODUCT]: 'Byproduct',
};
